module.exports = __webpack_public_path__ + "img/首页-证书3.17b3a06f.jpg";